import AppDispatcher from "../Dispatcher";
import AppSDK from "@growthos/ui-app-sdk";
import { AppActionConstants } from "./AppActionConstants";
import AppConfig from "../../AppConfig";
import { fetchWithAuthGet, fetchWithAuthPost } from "../FetchWithAuth";
import BookFiltersStore from "../Stores/BookFiltersStore";

const basePath = AppConfig.getBookApiBasePath();

export const fetchLineItems = (config, campaignUniqueID) => {
	const contextValues = BookFiltersStore.getContextValues();
	return Promise.all([
		fetchWithAuthGet(
			`${basePath.ApiBasePath}/plook/TaxonomyConfiguration/getHeaders/${contextValues.contextId}/${contextValues?.agency?.name}/${contextValues?.client?.name}/${contextValues?.region?.name}/${contextValues?.country?.name}/${config.platform.value}/${config.auditlevel.value}/${campaignUniqueID}`
		),
		fetchWithAuthGet(
			`${basePath.ApiBasePath}/plook/Campaign/getalllineitems/${contextValues.contextId}/${contextValues?.agency?.name}/${contextValues?.client?.name}/${contextValues?.region?.name}/${contextValues?.country?.name}/${config.platform.value}/${config.auditlevel.value}/${campaignUniqueID}`
		)
	]).then((response) => {
		// do something with both responses
		const config = response[0];
		const data = response[1];
		const lineItemData = {
			config,
			data
		};
		AppDispatcher.dispatch({
			type: AppActionConstants.fetchLineItems,
			value: lineItemData
		});
	});
};

export const createChildLineItems = (placementData, config, campaignUniqueID) => {
	const user = AppSDK.ApiUser.getUser();
	placementData.FirstName = user?.givenName;
	placementData.LastName = user?.familyName;
	placementData.Email = user?.userName;
	const contextValues = BookFiltersStore.getContextValues();

	const postData = JSON.stringify(placementData);
	return fetchWithAuthPost(`${basePath.ApiBasePath}/plook/LineItemSaveViewModel/InsertUpdateLineItems`, postData)
		.then((response) => {
			return Promise.all([
				fetchWithAuthGet(
					`${basePath.ApiBasePath}/plook/TaxonomyConfiguration/getHeaders/${contextValues.contextId}/${contextValues?.agency?.name}/${contextValues?.client?.name}/${contextValues?.region?.name}/${contextValues?.country?.name}/${config.platform.value}/${config.auditlevel.value}/${campaignUniqueID}`
				),
				fetchWithAuthGet(
					`${basePath.ApiBasePath}/plook/Campaign/getalllineitems/${contextValues.contextId}/${contextValues?.agency?.name}/${contextValues?.client?.name}/${contextValues?.region?.name}/${contextValues?.country?.name}/${config.platform.value}/${config.auditlevel.value}/${campaignUniqueID}`
				)
			]).then((response) => {
				// do something with both responses
				const config = response[0];
				const data = response[1];
				const lineItemData = {
					config,
					data
				};
				AppDispatcher.dispatch({
					type: AppActionConstants.childLineItemsSuccess,
					value: lineItemData
				});
			});
		})
		.catch(async (error) => {
			const errorObject = await error.details.json();
			AppDispatcher.dispatch({
				type: AppActionConstants.childLineItemsFail, // "updatePlacementDataFail"
				value: errorObject
			});
		});
};

export const fetchOnlyLineItems = (config, campaignUniqueID) => {
	const contextValues = BookFiltersStore.getContextValues();
	return fetchWithAuthGet(
		`${basePath.ApiBasePath}/plook/Campaign/getalllineitems/${contextValues.contextId}/${contextValues?.agency?.name}/${contextValues?.client?.name}/${contextValues?.region?.name}/${contextValues?.country?.name}/${config.platform.value}/${config.auditlevel.value}/${campaignUniqueID}`
	).then((response) => {
		AppDispatcher.dispatch({
			type: AppActionConstants.fetchOnlyLineItems,
			value: response
		});
	});
};

export const fetchOnlyLineItemConfig = (config, campaignUniqueID) => {
	const contextValues = BookFiltersStore.getContextValues();
	return fetchWithAuthGet(
		`${basePath.ApiBasePath}/plook/TaxonomyConfiguration/getHeaders/${contextValues.contextId}/${contextValues?.agency?.name}/${contextValues?.client?.name}/${contextValues?.region?.name}/${contextValues?.country?.name}/${config.platform.value}/${config.auditlevel.value}/${campaignUniqueID}`
	).then((response) => {
		AppDispatcher.dispatch({
			type: AppActionConstants.fetchOnlyLineItemsConfig,
			value: response
		});
	});
};

export const putLineItem = (data, closeModal) => {
	/* API ENDPOINT /Book2API/custom/InsertMasterCampaign */

	const user = AppSDK.ApiUser.getUser();
	data.FirstName = user?.givenName;
	data.LastName = user?.familyName;
	data.Email = user?.userName;

	const postData = JSON.stringify(data);
	let type = AppActionConstants.createLineItemSuccess;
	if (closeModal === false) {
		type = AppActionConstants.createAndAddLineItemSuccess;
	}
	return fetchWithAuthPost(`${basePath.ApiBasePath}/plook/LineItemSaveViewModel/InsertUpdateLineItems`, postData)
		.then((resp) => {
			AppDispatcher.dispatch({
				type,
				value: resp[1].Object
			});
		})
		.catch(async (error) => {
			const errorObject = await error.details.json();
			AppDispatcher.dispatch({
				type: AppActionConstants.createLineItemFail,
				value: errorObject[1].Object
			});
		});
};

export const editLineItem = (data, row) => {
	/* API ENDPOINT /Book2API/custom/InsertMasterCampaign */

	const user = AppSDK.ApiUser.getUser();
	data.FirstName = user?.givenName;
	data.LastName = user?.familyName;
	data.Email = user?.userName;

	const postData = JSON.stringify(data);
	return fetchWithAuthPost(`${basePath.ApiBasePath}/plook/LineItemSaveViewModel/InsertUpdateLineItems`, postData)
		.then((resp) => {
			AppDispatcher.dispatch({
				type: AppActionConstants.editLineItemSuccess,
				value: resp[1].Object,
				row
			});
		})
		.catch(async (error) => {
			const errorObject = await error.details.json();
			AppDispatcher.dispatch({
				type: AppActionConstants.editLineItemFail,
				value: errorObject[1].Object
			});
		});
};

export const updateLineItemsSheet = (postData) => {
	const user = AppSDK.ApiUser.getUser();
	postData.FirstName = user?.givenName;
	postData.LastName = user?.familyName;
	postData.Email = user?.userName;

	return fetchWithAuthPost(`${basePath.ApiBasePath}/plook/LineItemSaveViewModel/InsertUpdateLineItems`, JSON.stringify(postData));
};

export const setFilteredData = (data) => {
	AppDispatcher.dispatch({
		type: AppActionConstants.setFilteredLineItems,
		value: data
	});
};

export const setFilteredIO = (data) => {
	AppDispatcher.dispatch({
		type: AppActionConstants.setFilterIO,
		value: data
	});
};

export const deleteChildLineItems = (insertionOrderID) => {
	AppDispatcher.dispatch({
		type: AppActionConstants.deleteChildLineItems,
		value: insertionOrderID
	});
};
export const triggerLineItemModal = () => {
	AppDispatcher.dispatch({
		type: AppActionConstants.triggerLineItemModal
	});
};

export const pushLineItemsToDV360 = (lineItemIDs) => {
	return fetchWithAuthPost(`${basePath.ApiBasePath}/plook/LineItem/AddLineItemsToDV360`, JSON.stringify({ LineItemIDs: lineItemIDs }));
};

export const updateLineItemsSyncStatus = (lineItemIDs) => {
	AppDispatcher.dispatch({
		type: AppActionConstants.updateLineItemsSyncStatus,
		value: lineItemIDs
	});
};
